module.exports = __webpack_public_path__ + "img/img1.693c71c3.png";